import { render } from "./DepartmentSummaryNote.vue?vue&type=template&id=55ac87fc&scoped=true&ts=true"
import script from "./DepartmentSummaryNote.vue?vue&type=script&lang=ts"
export * from "./DepartmentSummaryNote.vue?vue&type=script&lang=ts"

import "./DepartmentSummaryNote.vue?vue&type=style&index=0&id=55ac87fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ac87fc"]])

export default __exports__